/**
 * 导航栏逻辑 Composable
 */
import { computed } from 'vue';
import { globalProperties } from '@/main';

export function useNavigation(page, deviceType, loadState) {
  const themeColor = globalProperties.$themeColor;
  
  // 是否显示导航栏
  const ifShowNav = computed(() => {
    if (page.value === 'AgentPage' || (loadState.value && ['WelcomePage', 'LoginPage', 'ChatPage', 'DocumentPage', 'DeveloperPage', 'DevPage', undefined, null].includes(page.value))) {
      return false;
    } else {
      return true;
    }
  });
  
  // 导航栏背景颜色
  const navColor = computed(() => {
    if (page.value == "SelfPage" || page.value == 'ManagePage') {
      return '#ffffff';
    } else {
      return themeColor;
    }
  });
  
  // 导航栏图标颜色
  const navIconColor = computed(() => {
    if (page.value == "SelfPage" || page.value == 'ManagePage') {
      return themeColor;
    } else {
      return "#ffffff";
    }
  });
  
  // 路由上边距
  const routerMarginTop = computed(() => {
    if (ifShowNav.value) {
      return '45px';
    } else {
      return '0px';
    }
  });
  
  // 是否显示首页按钮
  const ifShowHomeBtn = computed(() => {
    return page.value == "ArticlePage" || page.value == "PostPage" || page.value == "CoursePage" || 
           page.value == "SelfPage" || page.value == "ManagePage" || page.value == "EditorPage" || 
           page.value == "SearchPage" || page.value == "ErrorPage" || page.value == "AuthorPage" || 
           page.value == "ServicePage" || page.value == "AgentPage" || page.value == "RagChatPage" || page.value == "SectionPage" || page.value == "SectionSetPage";
  });
  
  // 是否显示头像
  const ifShowAvatar = computed(() => {
    if (page.value == "SelfPage" || page.value == 'ManagePage') {
      return false;
    } else {
      return true;
    }
  });
  
  // 是否显示顶部编辑按钮
  const ifShowTopEditBtns = computed(() => {
    return deviceType.value === 'desktop' && ['IndexPage', 'SelfPage'].includes(page.value);
  });
  
  // 是否显示服务按钮
  const ifShowService = computed(() => {
    return ['IndexPage'].includes(page.value);
  });
  
  // 是否可以显示搜索建议
  const ifCanSearchInputSuggestion = computed(() => {
    return !['SearchMobilePage'].includes(page.value);
  });
  
  return {
    themeColor,
    ifShowNav,
    navColor,
    navIconColor,
    routerMarginTop,
    ifShowHomeBtn,
    ifShowAvatar,
    ifShowTopEditBtns,
    ifShowService,
    ifCanSearchInputSuggestion,
  };
}
